import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<{ disabled: boolean }>()(
  (theme, { disabled }) => ({
    link: {
      textDecoration: "none",
      pointerEvents: disabled ? "none" : "auto",
      width: "100%",
    },
    googleButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing(1.5),
      width: "100%",
      padding: theme.spacing(2),
      textTransform: "none",
      fontWeight: 500,
      fontSize: "0.875rem",
      color: "#0A1A2F",
      backgroundColor: "#ffffff",
      border: "1px solid #d2d2d7",
      borderRadius: theme.spacing(3),
      transition: "all 0.2s",
      "&:hover": {
        backgroundColor: "#ffffff",
        borderColor: "#86868b",
        transform: "translateY(-1px)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      },
    },
    googleIcon: {
      fontSize: "1.25rem",
    },
    modalContent: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing(2),
    },
  })
);
